<div
    class="brand"
    [class.full-height]="backgroundImage()"
    [style.backgroundImage]="backgroundImage() ? 'url(' + backgroundImage() + ')' : ''"
>
    <img
        fetchpriority="high"
        loading="lazy"
        logoFallback
        [alt]="brandName()"
        [ariaLabel]="ariaLabel()"
        [brandName]="brandName()"
        [fallbackColor]="fallbackColor()"
        [fallbackFontSize]="fallbackFontSize()"
        [inputSrc]="url()"
        [style.maxWidth.px]="maxWidth()"
    />
</div>
